import { SEASONS } from "models";
import { enumToDropdownOptions } from "utils/common";

import type { DropdownItemProps } from "components";
import type { TFunction } from "i18next";

export const getTyreSeasonOptions = (t: TFunction): DropdownItemProps<number>[] => enumToDropdownOptions({ enumObj: SEASONS, t });
export const getTyreSeasonName = (season: SEASONS, t: TFunction) => getTyreSeasonOptions(t).find(option => option.value === season)?.text ?? "";
